module.exports = __webpack_public_path__ + "img/news1.525670c0.png";